import BlankTemplate from "../../layouts/BlankLayout";
import { useAccount } from "@vojomo-core/shared";

export function Unauthorized(): React.ReactElement {
  const { fullLogout } = useAccount();

  return (
    <BlankTemplate>
      <div>
        {/* Vojomo Icon */}
        <h2>You are not authorized to enter the Vojomo Admin App.</h2>

        <h4>
          Please click{" "}
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              fullLogout();
            }}
            className="font-bold no-underline text-vojomo-blue"
          >
            here
          </a>{" "}
          to try logging in as a different user.
        </h4>
        <br />
      </div>
    </BlankTemplate>
  );
}
